"use client";

import NextScript from "next/script";
import React from "react";
import { pushDataLayer } from "../../../helpers/dataLayer";
import { useConsent, useIsPay } from "../../Consent/hooks";

const GEOEDGE_KEY = process.env.NEXT_PUBLIC_GEOEDGE_KEY;
export const GeoEdge: React.FC = () => {
    const consent = useConsent();
    const isPay = useIsPay();

    if (!consent || isPay || !GEOEDGE_KEY) {
        return null;
    }

    return (
        <>
            <NextScript id="geo-edge-key-init" strategy="lazyOnload">
                {`
                    window.grumi = {
                        cfg: {
                            advs: {
                                4843926875: true,
                                4849834218: true,
                                4849836852: true,
                                4849839273: true,
                                4850043332: true,
                                4850702791: true,
                                4850710792: true,
                                4858843634: true,
                                4952552599: true,
                                5010478933: true,
                                5128372021: true,
                                5153903891: true,
                                5154539683: true,
                                5154545236: true,
                                5163616210: true,
                                5188215050: true,
                                5188771806: true,
                                5340483820: true,
                                5769936840: true,
                                5803592573: true,
                                5856844790: true,
                                5923589741: true
                            }
                        },
                        key: '${GEOEDGE_KEY}'
                    };
                `}
            </NextScript>
            <NextScript
                id="geo-edge"
                strategy="lazyOnload"
                src={`//rumcdn.geoedge.be/${GEOEDGE_KEY}/grumi-ip.js`}
                onError={(): void => {
                    pushDataLayer({ type: "adBlock", adBlock: "Yes" });
                }}
            />
        </>
    );
};
